import { render, staticRenderFns } from "./accessoriesList.vue?vue&type=template&id=be09b0b4&scoped=true"
import script from "./accessoriesList.vue?vue&type=script&lang=js"
export * from "./accessoriesList.vue?vue&type=script&lang=js"
import style0 from "./accessoriesList.vue?vue&type=style&index=0&id=be09b0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be09b0b4",
  null
  
)

export default component.exports